import { NavLink } from 'react-router-dom';

interface NavigationItemProps {
  navigateTo: string;
  label: string;
  onClick?: () => void;
}

const NavigationItem = ({ label, navigateTo, onClick }: NavigationItemProps) => {
  return (
    <NavLink
      to={navigateTo}
      onClick={onClick}
      className={({ isActive }) =>
        isActive ? 'nav-item-link active' : 'nav-item-link'
      }
    >
      <span className="nav-item-label">{label}</span>
    </NavLink>
  );
};

export default NavigationItem;
